// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fW","heroImageWrapper":"fX","gradientLeft":"fY","gradientBottom":"fZ","brandLogo":"f0"};